import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/common.json";
import ar from "./locales/ar/common.json";
import sv from "./locales/sv/common.json";

export const SUPPORTED_LANGUAGES = ["en", "ar", "sv"];
export const RTL_LANGUAGES = ["ar"];

const STORAGE_KEY = "invoicepro.lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      ar: { common: ar },
      sv: { common: sv },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: "common",
    ns: ["common"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

function applyDirAndLang(lng) {
  const lang = SUPPORTED_LANGUAGES.includes(lng) ? lng : "en";
  const dir = RTL_LANGUAGES.includes(lang) ? "rtl" : "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
  }
}

applyDirAndLang(i18n.language || "en");
i18n.on("languageChanged", applyDirAndLang);

export default i18n;
